import React, { Component } from 'react';
import {Spinner, Row, Col, Button } from 'react-bootstrap';
import {TokenValidation, InventoryUserMappedAction} from '../Dashboard/UserActions';
import {InventoryMaster} from '../Inventory/InventoryAction';
import {ClidReportGenerate, resetReport, ClidReportDownload, closeModalPopUp, BasedOnInventory} from './ReportsActions';
import { connect } from 'react-redux';	
import ShowModalPopUp from '../ShowModalPopUp';
import DatePicker from "react-datepicker";
import moment from "moment";
import ReportManagementOne from './ReportManagementOne';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import {URL_API_MANAGEMENT_SUMMARY_CLIENT_VIEW_REPORT_GENERATE, URL_API_MANAGEMENT_SUMMARY_CLIENT_VIEW_REPORT_EXCEL} from '../apiHitFile';
import _ from 'lodash';

 class ManagementView extends Component { 
  constructor(props){
    super(props)
    this.state= {
      selectedclientName:[],
      selectedcenterName:[],
      selectedprocessName:[],
      selectedregionName:[],
      saveClicked:false,
      GenerateReport:false,
      toggleA:true
    }
   }
  componentDidMount(){    
    this.props.BasedOnInventory()
    this.props.resetReport()
  }

  clientsName = () => {
    const{processBasedValue} = this.props;
    let clientsName=[];
    if(!_.isEmpty(processBasedValue)){
      clientsName =  processBasedValue.clientProcessList
      }
    return clientsName;
  }   
 
   
  processName = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
        processName = selectedclientName.process
        processName=_.uniqBy(processName, 'inventoryProcessId');

    }
    return processName;
  } 
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});  
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], GenerateReport:false})
    }
  }
  
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
    if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({GenerateReport:false})
    }
  }

  handleChangeStart = (date) => {
    this.setState({startDate: date});
  }
  validateInput = () =>{
    const { selectedclientName, startDate, selectedprocessName} = this.state
    if(!_.isEmpty(selectedclientName) && !_.isEmpty(selectedprocessName) 
     && typeof startDate !== "undefined"){
      return true
    }
  } 
  generateReport = () => {
    const {selectedclientName, selectedprocessName, startDate} = this.state
    let processObj = _.map(selectedprocessName, (obj) => {
      return ({[obj.inventoryProcessId]:obj.inventoryProcessName})
    })
    processObj = Object.assign({}, ...processObj)
    let obj = {
      "date":moment(startDate).format('YYYY-MM-DD'),
      "clients":{[selectedclientName.inventoryClientId]:selectedclientName.inventoryClientName},
      "processes":processObj
    }
    // let obj = {
    //     "clients": {
    //       "45": "VIL",
    //     },
    //     "processes": {
    //       "64": "Inbound-Voda",
    //       "66": "Inbound-Voda",
    //     },
    //    "date": "2020-06-11"
    // }
    this.props.TokenValidation()
    this.props.ClidReportGenerate(obj, URL_API_MANAGEMENT_SUMMARY_CLIENT_VIEW_REPORT_GENERATE)
    this.setState({GenerateReport:true})
    // this.setState({GenerateReport:true}, ()=>this.handleToggle())
  }
  handleToggle = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  downloadReport= () =>{
    const {selectedclientName, selectedprocessName, startDate} = this.state
    let processObj = _.map(selectedprocessName, (obj) => {
      return ({[obj.inventoryProcessId]:obj.inventoryProcessName})
    })
    processObj = Object.assign({}, ...processObj)
    let obj = {
      "date":moment(startDate).format('YYYY-MM-DD'),
      "clients":{[selectedclientName.inventoryClientId]:selectedclientName.inventoryClientName},
      "processes":processObj
    }
  //   let obj = {
  //     "clients": {
  //       "45": "VIL",
  //     },
  //     "processes": {
  //       "64": "Inbound-Idea",
  //       "66": "Inbound-Voda",
  //     },
  //    "date": "2020-06-11"
  // }
     this.props.TokenValidation()
     this.props.ClidReportDownload(obj, URL_API_MANAGEMENT_SUMMARY_CLIENT_VIEW_REPORT_EXCEL, "MANAGEMENT_SUMMARY_1_CLIENT.xlsx")
   }

	render(){
    const {GenerateReport, toggleA} = this.state;  
		let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }	
		return(
			<div  className={(style) ? 'user' : "userSmall"}>			
				{(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
        <div>
          <h6 onClick={this.handleToggle} >
          {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>&nbsp;REPORT CRITERIA</b></h6>  
        <div className={toggleA ? '': 'assesmentHide'}>  
          <Row className="marginBottom">  
            <Col>
              <label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
              <Picky keepOpen={false}
              value={this.state.selectedclientName}
              options={this.clientsName()}
              onChange={this.handleSelectClient}
              open={false}
              valueKey="inventoryClientId"
              labelKey="inventoryClientName"
              multiple={false}
              includeSelectAll={true}
              includeFilter={false}
              placeholder='Select Clients'
              dropdownHeight={600}
              />
          </Col> 
            <Col>
              <label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
              <Picky keepOpen={false}
              value={this.state.selectedprocessName}
              options={this.processName()}
              onChange={this.handleSelectProcess}
              open={false}
              valueKey="inventoryProcessId"
              labelKey="inventoryProcessName"
              multiple={true}
              includeSelectAll={true}
              includeFilter={false}
              placeholder='Select Process'
              dropdownHeight={600}
              />
          </Col>
          <Col>
          <label><b>DATE<span className="RedColoring"> *</span></b></label>
          <DatePicker
          selected={this.state.startDate}
          className='myDatePicker'
          selectsStart
          showMonthDropdown
          startDate={this.state.startDate}
          onChange={this.handleChangeStart}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select Date"          
         />
          </Col> 
          </Row> 
       </div>
          <Button className='buttonwidth alignInline alignRight' 
            onClick={this.generateReport}>Generate Report</Button>
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)  && !_.isEmpty(this.props.reportData.value)) ? 
          <Button className='buttonwidth alignInline alignRight' onClick={this.downloadReport}>Download Report</Button> : null}
          {((GenerateReport === true) && !_.isEmpty(this.props.reportData)) ?
          <ReportManagementOne  reportData={this.props.reportData}/>
          : null }
        </div> 
			</div>)
	}

}
function mapStateToProps(state){
  return{
    size: state.UserReducer.large,    
    processBasedValue: state.ReportsReducer.processBasedValue,
    reportData: state.ReportsReducer.reportData, 
    isPending: state.ReportsReducer.isPending,
    showerror:  state.ReportsReducer.showerror, 
    errmessage:  state.ReportsReducer.errmessage
   }  
}

const mapDispatchToProps = (dispatch) => ({
  BasedOnInventory:  (a) =>dispatch(BasedOnInventory(a)),
  ClidReportGenerate: (a, b) => dispatch(ClidReportGenerate(a,b)),
  ClidReportDownload: (a, b, c) => dispatch(ClidReportDownload(a, b, c)),
  resetReport: () => dispatch(resetReport()),
  TokenValidation : () => dispatch(TokenValidation()),
  closeModalPopUp:  () =>dispatch(closeModalPopUp()), 
  
})


export default connect(mapStateToProps, mapDispatchToProps)(ManagementView);     